import invariant from 'invariant';
import queryString from 'query-string';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';

export default function getDesigners(designersConfigs) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, parentCategory = '', options } = designersConfigs;

    invariant(baseUrl, 'baseUrl is a required param of getDesigners()');
    invariant(brandId, 'brandId is a required param of getDesigners()');
    invariant(country, 'country is a required param of getDesigners()');
    invariant(clientId, 'clientId is a required param of getDesigners()');

    const headers = { 'Content-Type': 'application/json' };

    const queries = options ? `?${queryString.stringify(options)}` : '';
    const fetchUrl = `${baseUrl}search/resources/store/${brandId}_${country.toLowerCase()}/categoryview${parentCategory}/designers${queries}`;

    return labelRequest(
        authenticatedRequest(new Request(fetchUrl, { headers: new Headers(headers), method: 'GET' }), uberToken, clientId, clientSecret),
        'getDesigners',
    );
}
